import { iam } from '@myap/ui-library/esm/profile'
import axios, { getServerErrorMessage } from '../utils/axios'
import * as c from '../constants/DpaAgreementConstants'

const { getJWTToken, getAuthSession } = iam()

export const getDpaAgreement = orgId => async dispatch => {
  try {
    dispatch({ type: c.FETCH_DPA_AGREEMENT_REQUEST_PENDING })
    const config = {
      headers: {
        'X-CB-Catapult-Authentication-Token': getAuthSession().sessionId,
        'X-CB-Catapult-Authorization-Token': getJWTToken(),
      },
      params: {
        fallback: true,
      },
    }
    const { data } = await axios.get(
      `${Config.API_GATE_URL}/digital-privacy-agreement/organizations/${orgId}`,
      config
    )
    dispatch({
      type: c.FETCH_DPA_AGREEMENT_REQUEST_FULFILLED,
      payload: data,
    })
  } catch (err) {
    if (err.response?.status === 404) {
      dispatch({
        type: c.FETCH_DPA_AGREEMENT_REQUEST_FULFILLED,
      })
      return
    }
    dispatch({ type: c.FETCH_DPA_AGREEMENT_REQUEST_REJECTED, payload: getServerErrorMessage(err) })
  }
}
